import { render, staticRenderFns } from "./left-chart.vue?vue&type=template&id=0f5ffb10&scoped=true&"
import script from "./left-chart.vue?vue&type=script&lang=js&"
export * from "./left-chart.vue?vue&type=script&lang=js&"
import style0 from "./left-chart.vue?vue&type=style&index=0&id=0f5ffb10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ffb10",
  null
  
)

export default component.exports